import { CommonModule } from '@angular/common';
import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { ToHtmlPipe } from 'src/app/shared/utilities/to-htmlpipe/to-html.pipe';

@Component({
  selector: 'app-common-subproducts-video',
  templateUrl: './video.component.html',
  styleUrls: ['./video.component.scss'],
  imports: [CommonModule, ToHtmlPipe],
})
export class CommonSubProductsVideoComponent implements OnInit {
  @Input() videoData: any;
  @Input() customClass: any;
  constructor() {}
  _videoData: any;
  isPlaying: boolean = false;
  ngOnInit(): void {
    this._videoData = this.videoData;
  }
  ngOnChanges(): void {
    this._videoData = this.videoData;
  }
  playVideo(videoPlayer: HTMLVideoElement) {
    videoPlayer.play();
    this.isPlaying = true;
  }

  onPlay() {
    this.isPlaying = true;
  }

  onPause() {
    this.isPlaying = false;
  }
}
